import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { LogoWithText } from './Logo';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', path: '/' },
    { name: 'Products', path: '/products' },
    { name: 'Shop', path: '/shop' },
    { name: 'Catalogs', path: '/catalogs' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 w-full bg-white/98 backdrop-blur-md shadow-sm z-50 border-b border-gray-200">
      {/* Top bar */}
      <div className="bg-gradient-to-r from-yellow-50 via-yellow-100 to-yellow-50 border-b border-yellow-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-2 text-sm">
            <div className="flex items-center gap-4">
              <a href="tel:+15877090167" className="flex items-center gap-1 text-gray-700 hover:text-yellow-700 transition-colors font-medium">
                <Phone className="w-3 h-3" />
                <span>+1-587-709-0167</span>
              </a>
              <a href="mailto:info@univsurgical.com" className="flex items-center gap-1 text-gray-700 hover:text-yellow-700 transition-colors font-medium">
                <Mail className="w-3 h-3" />
                <span>info@univsurgical.com</span>
              </a>
            </div>
            <div className="hidden sm:block text-xs font-semibold text-yellow-700">
              ISO 9001 Certified | Luxury Beauty Instruments
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/">
            <LogoWithText size="default" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-sm font-medium transition-colors relative group ${isActive(item.path) ? 'text-yellow-700 font-semibold' : 'text-gray-700 hover:text-yellow-700'}`}
              >
                {item.name}
                <span
                  className={`absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-yellow-600 to-yellow-500 transition-transform origin-left ${isActive(item.path) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`}
                />
              </Link>
            ))}
            <Link to="/contact">
              <Button className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-medium shadow-md">
                Request Quote
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-red-600 hover:bg-red-50 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4 space-y-2 bg-white">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`block px-4 py-2 rounded-md text-sm font-medium transition-colors ${isActive(item.path) ? 'bg-red-50 text-red-600 font-semibold' : 'text-gray-700 hover:bg-red-50 hover:text-red-600'}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white mt-2">
                Request Quote
              </Button>
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};
